<div class="header-offers">
  <div class="container-fluid">
    <ng-container
      *ngIf="{
        shopping: productUtilService.isShoppingEnabled$ | async,
        wholesale: mxWholeSale$ | async
      } as viewModel"
    >
      <div class="row py-2" *ngIf="viewModel.shopping">
        <div
          [ngClass]="viewModel.wholesale ? 'col-12' : 'col-6'"
          class="p-0 d-flex align-items-center"
        >
          <div [ngClass]="{ 'host-offers': true, 'separator-right': !viewModel.wholesale }">
            <img class="icon" src="assets/images/header/USERS.svg" alt="Users" />
            <a class="link pl-2" [routerLink]="'/' + Routes.HostessSpecialOffers" i18n
              >Host Offers</a
            >
          </div>
        </div>
        <div class="col-6 p-0 d-flex align-items-center" *ngIf="!viewModel.wholesale">
          <div class="customer-offers">
            <img class="icon" src="assets/images/header/TAG.svg" alt="Tag" />
            <a class="link pl-2" [routerLink]="'/' + Routes.CustomerSpecialOffers" i18n
              >Customer Offers</a
            >
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
